export function toId(label: string) {
  return encodeURIComponent(label.toLowerCase().replaceAll(" ", "-"));
}
